module.exports = new __parcel__URL__("75258_h.ebfe0fbd.jpg").toString();